import { render, staticRenderFns } from "./CreateSupporter.vue?vue&type=template&id=2b8fe50c&scoped=true&"
import script from "./CreateSupporter.vue?vue&type=script&lang=js&"
export * from "./CreateSupporter.vue?vue&type=script&lang=js&"
import style0 from "./CreateSupporter.vue?vue&type=style&index=0&id=2b8fe50c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8fe50c",
  null
  
)

export default component.exports